import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/weekly_schedule_actions';
import moment from 'moment-timezone'
import { InputField } from '../../../common/InputField';


export class WeeklyScheduleContainer extends Component {
    constructor(props){
        super(props);
        
        const agentID = props.agentID ? props.agentID : props.User.userID;
        const teamID = props.teamID ? props.teamID : props.User.teamID;
        const muID = props.muID ? props.muID : props.User.managementUnitID;

        this.state = {
            totalHours: 0,
            daySchedules: [],
            isSupervisorView: props.agentID !== undefined, // Agent ID from route
            agentID: agentID,
            agentName: props.agentName ? props.agentName : "",
            teamID: teamID,
            muID: muID
        };
    }

    componentDidMount = () => {
        const {
            props: {
                actions: {
                    fetchMUAction,
                    fetchTeamAction,
                    fetchAgentScheduleAction
                },
                selectedStartDate,
                selectedEndDate
            },
            state: {
                muID,
                teamID,
                agentID
            }
        } = this;

        fetchMUAction({ id: muID });
        fetchTeamAction({ id: teamID });
        fetchAgentScheduleAction({ 
            agentID, 
            StartScheduledDayKey: selectedStartDate.format('YYYY-MM-DD'),
            EndScheduledDayKey: selectedEndDate.format('YYYY-MM-DD')
        });
    }

    componentDidUpdate = (prevProps) => {
        const {
            props: {
                Schedule,
                actions: { fetchAgentScheduleAction },
                selectedStartDate,
                selectedEndDate,
            }, state: { agentID }
        } = this;

        if (prevProps.Schedule !== Schedule) {
            const { totalHours, daySchedules } = this.generateDaySchedules(Schedule);

            this.setState({ totalHours, daySchedules });
        }

        if (prevProps.selectedStartDate.format('YYYY-MM-DD') !== selectedStartDate.format('YYYY-MM-DD')) {
            fetchAgentScheduleAction({ 
                agentID, 
                StartScheduledDayKey: selectedStartDate.format('YYYY-MM-DD'),
                EndScheduledDayKey: selectedEndDate.format('YYYY-MM-DD')
            });
        }
    }

    generateTimeSummary(events) {
        var sortedEvents = events.sort(function(a, b){
            return a.StartTime-b.StartTime
        })
        const max = events.reduce((prev, current) => (prev.EndTime > current.EndTime) ? prev : current)

        var from =  sortedEvents[0].StartTime;
        var to = max.EndTime;
        var fromMoment = from.format('h:mm A');
        var toMoment = to.format('h:mm A');  
        var diff = moment.duration(to.diff(from));
        var duration = diff.asHours();

        return {
            totalTimespan: fromMoment + ' - ' + toMoment,
            duration: duration,
            sortedEvents: sortedEvents
        }
    }   

    generateDaySchedules(Schedule){ 
        let daySchedules = [];
        let totalHours = 0;
        let _this = this;
        if (typeof Schedule.Events === "undefined") 
            return {
                daySchedules,
                totalHours
            };

        Object.keys(Schedule.Events).forEach(function (key) {
            let events = Schedule.Events[key];
            let timeSummary = _this.generateTimeSummary(events);
            totalHours += parseFloat(timeSummary.duration);
            daySchedules.push( <DaySchedule
                key={key}
                dateKey={key} 
                totalTimespan={timeSummary.totalTimespan}
                duration={timeSummary.duration}
                sortedEvents={timeSummary.sortedEvents}
            />)            
          });          
        return {
            daySchedules,
            totalHours
        };
    }

    render() {
        const {
            ManagementUnit,
            Team
        } = this.props;
        
        
        let teamName =  Team !== undefined && 
                        Team !== null ? 
                        Team.TeamName : "";
        
        let managementUnitName =  ManagementUnit !== undefined &&
                                  ManagementUnit !== null ? 
                                  ManagementUnit.ManagementUnitName : "";
        return (
            <div className="weekly_schedule_container">
                <WeeklyScheduleHeading 
                    agentName={this.state.agentName}
                    teamName={teamName}
                    managementUnitName={managementUnitName}
                    isSupervisorView={this.state.isSupervisorView}
                    totalHours={this.state.totalHours} />              
                { this.state.daySchedules }                              
            </div>
        );
    }
}

class WeeklyScheduleHeading extends Component {  
    render() {
        let { isSupervisorView, agentName } = this.props;
        return (
            <div className="weekly_schedule_head">
                <div>{ isSupervisorView ? agentName : "Weekly Schedule" }</div>
                <div className="agent_meta">
                    <InputField
                        inputValue={this.props.managementUnitName}
                        labelValue="Management Unit"
                        disabled={true}
                    />
                    <InputField
                        inputValue={this.props.teamName}
                        labelValue="Team"
                        disabled={true}
                    />
                </div>
                <TotalHours label="Total Hours" 
                    hours={this.props.totalHours} 
                    isWrapAround={false}
                />
            </div>
        );
    }
}

class DaySchedule extends Component {
    render() {
        let { dateKey, totalTimespan, duration, sortedEvents } = this.props;
        return (
            <div className="day_container">
                <DayHeader
                    dateKey={dateKey}                  
                    totalTimeSpan={totalTimespan}
                    duration={duration}
                    isWrapAround={sortedEvents.findIndex(i => i.isWrapAround === true) > -1}
                 />
                <ActivityTable 
                    events={sortedEvents}
                />
            </div>
        );
    }
}



class TotalHours extends Component {
    render() {        
        let label = this.props.label;
        let hours = this.props.hours;
        return (
            <div className="total_hours">
                <span>{label} 
                <CarryForwardEvent
                    isWrapAround={this.props.isWrapAround}/>
                &nbsp; | &nbsp;</span>
                <span>{hours} Hrs</span>
            </div>
        );
    }
}

class DayHeader extends Component {
    
    render() {
        let day = moment(this.props.dateKey).format('ddd')
        let date = moment(this.props.dateKey).format('DD')
        let month = moment(this.props.dateKey).format('MMM')        

        return (
            <div className="day_header">
                <span className="full_date_holder">
                    <span className="day">{day} </span>
                    <span className="date">{date} </span>
                    <span className="month">{month}</span>
                </span>
                <span className="time_icon" />
                <TotalHours 
                label={this.props.totalTimeSpan}
                hours={this.props.duration} 
                isWrapAround = {this.props.isWrapAround}
                />
            </div>
        );
    }
}

class ActivityTable extends Component {

    generateActivityRow(events){
        var activities = []
        var previousEventEndTime = null;
        
        var maxEndTime = events.reduce((prev, current) => (prev.EndTime > current.EndTime) ? prev : current).EndTime
        var isCarryForward = false;
        var isFillerCarryForward = false;
        var isPreviousCarryForward = false;
        Object.keys(events).forEach(function (key) { 
            var index = parseInt(key, 10);
            var from =  events[key].StartTime   
            var to = events[key].EndTime
            
            isCarryForward = isCarryForward === true
            ? true :
                index > 0  ? 
                   minutesOfDay(previousEventEndTime.local()) > minutesOfDay(from.local())
                   || minutesOfDay(from.local()) > minutesOfDay(to.local()): 
                       false
            
            if(events[key].AgentScheduleCodeName === 'Work' && index < events.length-1 ){
                 from =  events[key].StartTime   
                 to = events[index].EndTime.local() > events[index+1].StartTime.local() ? events[index+1].StartTime : events[index].EndTime
            }
//Filler Work event if the starttime of current event is not the end time of previous event
            else if(previousEventEndTime != null && previousEventEndTime !== events[key].StartTime){
                var fillerEventFrom =  previousEventEndTime.clone().local()
                var fillerEventTo = events[index].StartTime.clone().local()                

                isFillerCarryForward = isFillerCarryForward
                                        || isPreviousCarryForward
                                        ? true :
                                            index > 0  ? 
                                            minutesOfDay(previousEventEndTime.local()) > minutesOfDay(fillerEventFrom.local())
                                            : false            
                                
                activities.push( <ActivityRow
                    key={'activityrow_filler_event' + key}
                    activity={'Work'}
                    from={fillerEventFrom}
                    to={fillerEventTo}
                    isWrapAround = {isFillerCarryForward && events.findIndex(i => i.isWrapAround === true) > -1}
                />)
            }         
            
           

            activities.push( <ActivityRow
                key={'activityrow' + key}
                activity={events[key].AgentScheduleCodeName}
                from={from}
                to={to}
                isWrapAround = {(isCarryForward) || (isFillerCarryForward && events.findIndex(i => i.isWrapAround === true) > -1)}
            />) 
//Last Work event if last event is not the end time

            if(index === events.length -1 && events[index].EndTime !== maxEndTime)
            {
                var newFrom = to;
                var newTo = maxEndTime
               

                activities.push( <ActivityRow
                    key={'activityrow_end' + key}
                    activity={'Work'}
                    from={newFrom}
                    to={newTo}
                    isWrapAround = {events.findIndex(i => i.isWrapAround === true) > -1}
                />)
            }
                
            previousEventEndTime = to;      
            isPreviousCarryForward =  isCarryForward      
          });          
        return activities;
    }
    render() {
        var activityRow = this.generateActivityRow(this.props.events)
        return (
            <table className="day_activity_table">
                <tbody>
                    {activityRow}                
                </tbody>
            </table>
        );
    }
}

class ActivityRow extends Component {
    getDuration(from, to) {
        return moment(new Date(to)).diff(new Date(from), "hours");
    }
    render() {
        let { activity} = this.props;        
        var diff = moment.duration(this.props.to.diff(this.props.from))        
        var duration = moment(diff._data).format('HH:mm');   

        var from = this.props.from.format('h:mm A');
        var to = this.props.to.format('h:mm A');

        return (
            <tr>
                <td>{activity}</td>
                <td>
                    {from} - {to}
                    <CarryForwardEvent
                        isWrapAround={this.props.isWrapAround}
                    />
                    
                </td>
                <td>{duration}</td>
            </tr>
        );
    }
}


class CarryForwardEvent extends Component{
    render(){
        let { isWrapAround } = this.props;
        return(
            <span className={ isWrapAround ? "carryforward_event" : "carryforward_event hide" }>
            +1
            </span>
        )
    }
}

function minutesOfDay(m){
    return m.minutes() + m.hours() * 60;
}

function mapStateToProps(state) {
	return {
        Schedule: state.schedules.Schedule,
        Team: state.schedules.Team,
        ManagementUnit: state.schedules.ManagementUnit,
        User: state.common.user,        
        selectedStartDate: state.schedules.selectedStartDate,
        selectedEndDate: state.schedules.selectedEndDate,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WeeklyScheduleContainer);


// WEBPACK FOOTER //
// ./src/features/schedules/Schedules/AgentSchedule/WeeklyScheduleContainer.js